module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hntsn"))).then(() => parcelRequire('hEqeo'));